import React, { useEffect, useState } from 'react';
import { apis, hooks, models } from "@vote4dance/judging-sdk";
import { HeaderContainer, BodyContainer } from "../../../../base-react/components/Container";
import { Typography, Button, notification, Space, Select, Input, List, Col, Row, Popover } from 'antd';
import { useParams } from "react-router-dom";
import { _T } from "../../../../base-react/src/Localization";
import { DeleteOutlined, MobileOutlined, PlusOutlined } from "@ant-design/icons";
var Api = apis.Api;
var Stream = hooks.streams.Stream;
var CompetitionUpdateSource = models.notifications.CompetitionUpdateSource;
var CompetitionFollowerSource = models.notifications.CompetitionFollowerSource;
var UserItem = models.users.UserItem;
import dayjs from 'dayjs';
import { useCompetition } from '../../../../base-react/hooks/Competition';
import { ButtonConfirm } from '../../../../base-react/components/ButtonConfirm';
const { Title, Text } = Typography;
const { TextArea } = Input;
const dateTimeFormat = 'YYYY-MM-DD HH:mm';
export const EventNotifications = () => {
    var _a;
    let { event_id } = useParams();
    const [inputCompetition, event, competitions, loadingCompetition, , canEdit] = useCompetition(event_id);
    const competitionUpdateSource = CompetitionUpdateSource(event_id);
    const [items, loadingItems] = Stream(competitionUpdateSource);
    const [followers, loadingFollowers] = Stream(CompetitionFollowerSource(event_id));
    const [list, setList] = useState([]);
    const [isLoading, setIsLoading] = useState();
    const [editItem, setEditItem] = useState();
    const [editText, setEditText] = useState('');
    const [editType, setEditType] = useState('schedule');
    const followerNames = (followers !== null && followers !== void 0 ? followers : []).map((user) => UserItem.getFullName ? UserItem.getFullName(user) : `${user.user_firstname} ${user.user_lastname}`);
    const followerCount = (_a = followers === null || followers === void 0 ? void 0 : followers.length) !== null && _a !== void 0 ? _a : 0;
    const followerPreview = followerNames.slice(0, 8);
    const hiddenFollowers = followerCount - followerPreview.length;
    const followerCountLabel = loadingFollowers ? _T('data.loading') : _T('notifications.followers', { count: followerCount });
    const followerPopoverContent = loadingFollowers
        ? _T('data.loading')
        : followerPreview.length
            ? (React.createElement(Space, { orientation: "vertical", size: 4 },
                React.createElement(Text, null, followerPreview.join(', ')),
                hiddenFollowers > 0 && React.createElement(Text, { type: "secondary" },
                    "+",
                    hiddenFollowers)))
            : _T('notifications.followers', { count: followerCount });
    useEffect(() => {
        setList(items ? items : []);
    }, [items]);
    const onAddItem = async () => {
        const newItem = {
            competition_update_id: 'new',
            competition_id: event_id,
            update_value: '',
            update_type: 'schedule',
            update_time: dayjs().utc().format(dateTimeFormat)
        };
        setList(a => [newItem, ...a]);
        onEditItem(newItem);
    };
    const onDeleteItem = (item, done) => {
        setIsLoading(item.competition_update_id);
        Api.destroy(`${competitionUpdateSource.url}/${item.competition_update_id}`)
            .then(() => {
            onCancelItem();
            done();
            setIsLoading(undefined);
        })
            .catch((err) => {
            setIsLoading(undefined);
            done();
            notification.error({
                message: err.message
            });
        });
    };
    const onSendNotifications = (item, done) => {
        setIsLoading(item.competition_update_id);
        Api.call(`${competitionUpdateSource.url}/${item.competition_update_id}`, "publish")
            .then(() => {
            setIsLoading(undefined);
            done();
            notification.success({
                message: _T('notifications.send')
            });
        })
            .catch((err) => {
            setIsLoading(undefined);
            done();
            notification.error({
                message: err.message
            });
        });
    };
    const onEditItem = async (item) => {
        if (editItem == item.competition_update_id) {
            // Save changes
            setIsLoading(item.competition_update_id);
            const newItem = {
                ...item,
                update_value: editText,
                update_type: editType
            };
            let action;
            if (item.competition_update_id == 'new') {
                action = Api.create(competitionUpdateSource.url, newItem);
            }
            else {
                action = Api.update(`${competitionUpdateSource.url}/${item.competition_update_id}`, newItem);
            }
            await action
                .then(() => {
                onCancelItem();
            })
                .catch((err) => {
                notification.error({
                    message: err.message
                });
            });
            setIsLoading(undefined);
        }
        else {
            // Set editing
            setEditItem(item.competition_update_id);
            setEditText(item.update_value);
            setEditType(item.update_type);
        }
    };
    const onCancelItem = () => {
        if (editItem == 'new') {
            setList(items ? items : []);
        }
        setEditItem(undefined);
        setEditText('');
        setEditType('schedule');
    };
    const onRenderItem = (item) => (editItem == item.competition_update_id ?
        React.createElement(List.Item, { actions: [
                React.createElement(Button, { type: "link", onClick: () => onEditItem(item), disabled: !canEdit, loading: isLoading == item.competition_update_id }, _T('common.save')),
                React.createElement(Button, { type: "link", onClick: onCancelItem, disabled: isLoading == item.competition_update_id }, _T('common.cancel.title')),
                item.competition_update_id != 'new' &&
                    React.createElement(ButtonConfirm, { title: _T('common.delete.title'), description: _T('common.delete.content', { name: _T('notifications.title').toLowerCase() }), onConfirm: (done) => onDeleteItem(item, done), buttonProps: {
                            type: 'link',
                            danger: true,
                            icon: React.createElement(DeleteOutlined, null),
                            disabled: !canEdit
                        } })
            ] },
            React.createElement(Space, { orientation: "vertical", style: { width: '100%' } },
                React.createElement(Select, { defaultValue: editType, onChange: setEditType, options: [
                        { value: 'schedule', label: _T('notifications.type.schedule') },
                        { value: 'competition', label: _T('notifications.type.competition') }
                    ] }),
                React.createElement(TextArea, { autoSize: true, defaultValue: item.update_value, disabled: isLoading == item.competition_update_id, onChange: (e) => setEditText(e.target.value), style: { width: '100%' } }),
                item.update_sent_at &&
                    React.createElement(Text, { type: "secondary" }, _T('notifications.sent-at', { value: dayjs.utc(item.update_sent_at).tz(event === null || event === void 0 ? void 0 : event.competition_timezone).format(dateTimeFormat) }))))
        :
            React.createElement(List.Item, { actions: item.update_sent_at ? [
                    React.createElement(Button, { type: "link", disabled: !canEdit, onClick: () => onEditItem(item) }, _T('common.edit'))
                ] : [
                    React.createElement(Button, { type: "link", disabled: !canEdit, onClick: () => onEditItem(item) }, _T('common.edit')),
                    React.createElement(ButtonConfirm, { title: _T('notifications.send'), description: _T('common.confirm'), onConfirm: (done) => onSendNotifications(item, done), buttonProps: {
                            type: 'link',
                            loading: isLoading == item.competition_update_id,
                            icon: React.createElement(MobileOutlined, null),
                            disabled: !canEdit
                        } })
                ] },
                React.createElement(Row, { gutter: 16 },
                    React.createElement(Col, null,
                        React.createElement(Text, null,
                            React.createElement(Text, { strong: true }, dayjs(item.update_time).format('L')),
                            " ",
                            _T('notifications.type.' + item.update_type)),
                        React.createElement("p", null,
                            React.createElement(Text, { type: "secondary" }, item.update_value)),
                        item.update_sent_at &&
                            React.createElement(Text, { type: "secondary" }, _T('notifications.sent-at', { value: dayjs.utc(item.update_sent_at).tz(event === null || event === void 0 ? void 0 : event.competition_timezone).format(dateTimeFormat) }))))));
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderContainer, null,
            React.createElement(Typography, null,
                React.createElement(Title, null, _T('notifications.title')))),
        React.createElement(BodyContainer, null,
            React.createElement(Space, { orientation: "vertical", style: { width: '100%' } },
                React.createElement(Popover, { placement: "right", content: followerPopoverContent, overlayStyle: { maxWidth: 320 } },
                    React.createElement(Text, { type: "secondary", style: { cursor: 'default' } }, followerCountLabel)),
                React.createElement(Button, { size: 'large', type: 'primary', onClick: onAddItem, icon: React.createElement(PlusOutlined, null), disabled: !canEdit }, _T('common.create', { name: _T('notifications.title').toLocaleLowerCase() })),
                React.createElement(List, { itemLayout: 'horizontal', dataSource: list, loading: loadingItems, bordered: true, renderItem: onRenderItem })))));
};
